import { Observable, catchError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { GetDefaultFuelSpecsResponse } from '@navstation-portal/fuel-specs/data-model/fuel-spec';
import { ApiErrorMapper, BASE_API_URL } from '@navstation-portal/shared/util/api';

@Injectable({
  providedIn: 'root',
})
export class FuelSpecsService {
  private http = inject(HttpClient);
  private readonly baseUrl = inject(BASE_API_URL);
  private apiError = inject(ApiErrorMapper).forFeature('FuelSpecs');

  getDefaultFuelSpecs(): Observable<GetDefaultFuelSpecsResponse> {
    return this.http
      .get<GetDefaultFuelSpecsResponse>(`${this.baseUrl}/v2/fuel_specifications/default`)
      .pipe(catchError(this.apiError.toApiError('getting the default fuel specs')));
  }
}
